/* omes — Product page interactions
   Ported from c_design/project/products/linen-overshirt.html.
   Scoped per-section via [data-omes-pdp]; multiple instances safe. */
(function () {
  function init(root) {
    if (!root || root.__omesInit) return;
    root.__omesInit = true;

    var form        = root.querySelector('.omes-form');
    var variantData = root.querySelector('[data-omes-variants]');
    var priceEl     = root.querySelector('[data-omes-price]');
    var priceCmpEl  = root.querySelector('[data-omes-price-compare]');
    var atcBtn      = root.querySelector('[data-omes-atc]');
    var buyNowBtn   = root.querySelector('[data-omes-buy-now]');
    var atcPrice    = root.querySelector('[data-omes-atc-price]');
    var idInput     = root.querySelector('[data-omes-variant-id]');
    var stockEl     = root.querySelector('[data-omes-stock]');
    var qtyEl       = root.querySelector('[data-omes-qty]');
    var galleryMain = root.querySelector('[data-omes-gallery-main]');
    var mainImg     = root.querySelector('.omes-gallery-main img.omes-main-img') || root.querySelector('.omes-gallery-main img');
    var counter     = root.querySelector('[data-omes-counter]');
    var thumbsWrap  = root.querySelector('[data-omes-thumbs]');
    var thumbs      = root.querySelectorAll('[data-omes-thumb]');
    var dotsWrap    = root.querySelector('[data-omes-dots]');
    var dots        = dotsWrap ? dotsWrap.querySelectorAll('span') : [];
    var total       = thumbs.length;

    var variants = [];
    if (variantData) {
      try { variants = JSON.parse(variantData.textContent); } catch (e) { variants = []; }
    }

    /* Colour → gallery image index, resolved server-side (variant image, alt
       text, or one-image-per-colour order). Used when variants carry no
       featured media of their own, which is the common case for imported feeds. */
    var colorMediaEl  = root.querySelector('[data-omes-color-media]');
    var colorMedia    = {};
    var declaredColorIdx = -1;
    if (colorMediaEl) {
      try { colorMedia = JSON.parse(colorMediaEl.textContent) || {}; } catch (e) { colorMedia = {}; }
      var dci = parseInt(colorMediaEl.getAttribute('data-omes-color-index'), 10);
      if (!isNaN(dci)) declaredColorIdx = dci;
    }

    /* ---------- Quantity stepper ---------- */
    if (qtyEl) {
      var input = qtyEl.querySelector('input');
      var btns  = qtyEl.querySelectorAll('button');
      if (input && btns.length === 2) {
        btns[0].addEventListener('click', function () { input.value = Math.max(1, (+input.value || 1) - 1); });
        btns[1].addEventListener('click', function () { input.value = Math.min(9, (+input.value || 1) + 1); });
      }
    }

    /* ---------- Variant pickers (button-style: swatches + size pills) ---------- */
    var optionInputs = root.querySelectorAll('button[data-omes-option]');
    optionInputs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.classList.contains('omes-size--disabled')) return;
        var idx = btn.getAttribute('data-omes-option');
        root.querySelectorAll('button[data-omes-option="' + idx + '"]').forEach(function (s) {
          s.classList.remove('omes-swatch--active', 'omes-size--active');
        });
        if (btn.classList.contains('omes-swatch')) btn.classList.add('omes-swatch--active');
        if (btn.classList.contains('omes-size'))   btn.classList.add('omes-size--active');
        root.querySelectorAll('button.omes-size[data-omes-option="' + idx + '"]').forEach(function (s) {
          s.setAttribute('aria-pressed', s === btn ? 'true' : 'false');
        });
        var label = btn.getAttribute('data-omes-option-label');
        var labelEl = root.querySelector('[data-omes-option-value="' + idx + '"]');
        if (labelEl) labelEl.textContent = '— ' + label;
        /* Switch the gallery straight away: applyVariant() bails when the picked
           colour has no variant for the currently-selected size, but the shopper
           still expects to see that colour. */
        if (btn.classList.contains('omes-swatch') && Object.prototype.hasOwnProperty.call(colorMedia, label)) {
          activateThumb(colorMedia[label]);
        }
        refreshOptionAvailability();
        applyVariant();
      });
    });

    /* ---------- Variant pickers (select dropdowns: size) ---------- */
    var optionSelects = root.querySelectorAll('select[data-omes-option]');
    optionSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var idx = sel.getAttribute('data-omes-option');
        var opt = sel.options[sel.selectedIndex];
        if (!opt || opt.disabled) return;
        var label = opt.getAttribute('data-omes-option-label') || opt.value;
        var labelEl = root.querySelector('[data-omes-option-value="' + idx + '"]');
        if (labelEl) labelEl.textContent = '— ' + label;
        applyVariant();
      });
    });

    function getSelectedOptions() {
      var opts = [];
      var n = root.querySelectorAll('[data-omes-option-group]').length;
      for (var i = 0; i < n; i++) {
        var sel = root.querySelector('select[data-omes-option="' + i + '"]');
        if (sel) {
          var o = sel.options[sel.selectedIndex];
          if (!o) return null;
          opts.push(o.getAttribute('data-omes-option-label') || o.value);
          continue;
        }
        var active = root.querySelector('button[data-omes-option="' + i + '"].omes-swatch--active, button[data-omes-option="' + i + '"].omes-size--active');
        if (!active) return null;
        opts.push(active.getAttribute('data-omes-option-label'));
      }
      return opts;
    }

    /* Cross out the size pills that no purchasable variant offers for the
       other options currently picked (colour, in practice). The server-side
       markup only knows global availability, so this narrows it per colour. */
    function refreshOptionAvailability() {
      if (!variants.length) return;
      var current = getSelectedOptions();
      if (!current) return;

      var indices = [];
      root.querySelectorAll('button.omes-size[data-omes-option]').forEach(function (btn) {
        var idx   = parseInt(btn.getAttribute('data-omes-option'), 10);
        var label = btn.getAttribute('data-omes-option-label');
        if (indices.indexOf(idx) === -1) indices.push(idx);
        var ok = variants.some(function (v) {
          var o = v.options || [];
          if (!v.available || o[idx] !== label) return false;
          return o.every(function (val, i) { return i === idx || val === current[i]; });
        });
        btn.classList.toggle('omes-size--disabled', !ok);
        if (ok) btn.removeAttribute('aria-disabled');
        else btn.setAttribute('aria-disabled', 'true');
      });

      /* Never leave a crossed-out size selected — fall back to the first size
         the shopper can actually buy in this colour. */
      indices.forEach(function (idx) {
        var pills  = root.querySelectorAll('button.omes-size[data-omes-option="' + idx + '"]');
        var active = root.querySelector('button.omes-size[data-omes-option="' + idx + '"].omes-size--active');
        if (active && !active.classList.contains('omes-size--disabled')) return;
        var next = null;
        pills.forEach(function (p) { if (!next && !p.classList.contains('omes-size--disabled')) next = p; });
        if (!next) return;
        pills.forEach(function (p) { p.classList.remove('omes-size--active'); p.setAttribute('aria-pressed', 'false'); });
        next.classList.add('omes-size--active');
        next.setAttribute('aria-pressed', 'true');
        var labelEl = root.querySelector('[data-omes-option-value="' + idx + '"]');
        if (labelEl) labelEl.textContent = '— ' + next.getAttribute('data-omes-option-label');
      });
    }

    function applyVariant() {
      var opts = getSelectedOptions();
      if (!opts || !variants.length) return;
      var match = variants.find(function (v) {
        return (v.options || []).every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;

      if (idInput)  idInput.value = match.id;
      if (priceEl)  priceEl.textContent = match.price;
      if (priceCmpEl) {
        if (match.compare_at_price && match.compare_at_price !== match.price) {
          priceCmpEl.textContent = match.compare_at_price;
          priceCmpEl.style.display = '';
        } else {
          priceCmpEl.style.display = 'none';
        }
      }
      if (atcPrice) atcPrice.textContent = '· ' + match.price;

      if (!_skipThumbSync) {
        var mediaIdx = -1;
        if (typeof match.featured_media_index === 'number' && match.featured_media_index >= 0) {
          mediaIdx = match.featured_media_index;
        } else {
          var ci = getColorOptionIndex();
          var colorLabel = ci >= 0 ? opts[ci] : null;
          if (colorLabel && Object.prototype.hasOwnProperty.call(colorMedia, colorLabel)) {
            mediaIdx = colorMedia[colorLabel];
          }
        }
        if (mediaIdx >= 0) activateThumb(mediaIdx);
      }

      if (atcBtn) {
        var atcLabel = atcBtn.querySelector('[data-omes-atc-label]');
        if (!match.available) {
          atcBtn.disabled = true;
          if (atcLabel) atcLabel.textContent = atcBtn.getAttribute('data-omes-soldout') || 'Sold out';
        } else {
          atcBtn.disabled = false;
          if (atcLabel) atcLabel.textContent = atcBtn.getAttribute('data-omes-add') || 'Add to bag';
        }
      }
      if (buyNowBtn) buyNowBtn.disabled = !match.available;
      if (stockEl) {
        var dot = stockEl.querySelector('.omes-stock-dot');
        var stockLabel = stockEl.querySelector('[data-omes-stock-label]');
        if (match.available) {
          if (stockLabel) stockLabel.textContent = stockEl.getAttribute('data-omes-instock') || 'In stock';
          if (dot) dot.className = 'omes-stock-dot';
        } else {
          if (stockLabel) stockLabel.textContent = stockEl.getAttribute('data-omes-outstock') || 'Sold out';
          if (dot) dot.className = 'omes-stock-dot omes-stock-dot--out';
        }
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      } catch (e) {}
      // The bundle block reprices its tiers on the new variant (initBundles).
      root.dispatchEvent(new CustomEvent('omes:variant-change'));
    }

    /* ---------- Gallery: thumb click → swap main image (desktop) ---------- */
    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    var imgWrapper = root.querySelector('[data-omes-img-wrapper]');
    var pdpRoot    = root;
    function getMaxImgHt() {
      var v = getComputedStyle(pdpRoot).getPropertyValue('--omes-pimg-max-ht').trim();
      if (!v || v === 'none') return 0;
      var n = parseFloat(v);
      return isFinite(n) ? n : 0;
    }

    var _lastSwapSrc = null;
    function swapMainImage(src, alt, zoomSrc) {
      if (!mainImg || !src) return;
      if (src === _lastSwapSrc) return;
      _lastSwapSrc = src;
      var pre = new Image();
      pre.src = src;
      var apply = function () {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = src;
        if (alt) mainImg.alt = alt;
        if (zoomSrc && imgWrapper) imgWrapper.setAttribute('data-zoom', zoomSrc);
        /* Each slide gets its own factor — rebuild rather than reuse the instance */
        initDrift();
      };
      if (pre.decode) {
        pre.decode().then(apply, apply);
      } else if (pre.complete) {
        apply();
      } else {
        pre.onload = apply;
        pre.onerror = apply;
      }
    }

    /* Find the color-option index — declared by the section, else inferred from swatches */
    function getColorOptionIndex() {
      if (declaredColorIdx >= 0) return declaredColorIdx;
      var firstSwatch = root.querySelector('button.omes-swatch[data-omes-option]');
      if (!firstSwatch) return -1;
      var n = parseInt(firstSwatch.getAttribute('data-omes-option'), 10);
      return isNaN(n) ? -1 : n;
    }

    /* Reverse of colorMedia: which colour owns this gallery image */
    function colorForMedia(mediaIdx) {
      var keys = Object.keys(colorMedia);
      for (var i = 0; i < keys.length; i++) {
        if (colorMedia[keys[i]] === mediaIdx) return keys[i];
      }
      return null;
    }

    /* When a thumb is selected, sync the color swatch to the variant that owns that media */
    function syncSwatchToMedia(mediaIdx) {
      if (!variants.length) return;
      var colorIdx = getColorOptionIndex();
      if (colorIdx < 0) return;
      var colorLabel = null;
      var match = variants.find(function (v) { return v.featured_media_index === mediaIdx; });
      if (match && match.options) colorLabel = match.options[colorIdx];
      if (!colorLabel) colorLabel = colorForMedia(mediaIdx);
      if (!colorLabel) return;
      var swatches = root.querySelectorAll('button.omes-swatch[data-omes-option="' + colorIdx + '"]');
      var changed = false;
      swatches.forEach(function (s) {
        var isMatch = s.getAttribute('data-omes-option-label') === colorLabel;
        if (isMatch && !s.classList.contains('omes-swatch--active')) changed = true;
        s.classList.toggle('omes-swatch--active', isMatch);
      });
      if (changed) {
        var labelEl = root.querySelector('[data-omes-option-value="' + colorIdx + '"]');
        if (labelEl) labelEl.textContent = '— ' + colorLabel;
        applyVariantNoThumb();
      }
    }

    /* Same as applyVariant but skips re-activating the thumb to avoid loops */
    var _skipThumbSync = false;
    function applyVariantNoThumb() {
      _skipThumbSync = true;
      try { applyVariant(); } finally { _skipThumbSync = false; }
    }

    var _skipScrollSync = false;
    function activateThumb(idx) {
      if (idx < 0 || idx >= total) return;
      thumbs.forEach(function (t, i) { t.classList.toggle('omes-gallery-thumb--active', i === idx); });
      var t = thumbs[idx];
      if (mainImg && t) {
        swapMainImage(t.getAttribute('data-omes-img-src'), t.getAttribute('data-omes-img-alt') || '', t.getAttribute('data-omes-zoom-src') || '');
      }
      if (imgWrapper && t) {
        var ar  = parseFloat(t.getAttribute('data-omes-aspect')) || 0.75;
        var mh  = getMaxImgHt();
        if (mh > 0) imgWrapper.style.maxWidth = (mh * ar) + 'px';
        else imgWrapper.style.maxWidth = '';
      }
      if (counter) counter.textContent = pad(idx + 1) + ' / ' + pad(total);
      if (dots && dots.length) {
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      }
      if (thumbsWrap && t && total > 1 && window.innerWidth <= 749) {
        var sw = thumbsWrap.scrollWidth;
        var current = Math.round(thumbsWrap.scrollLeft / (sw / total));
        if (current !== idx) {
          _skipScrollSync = true;
          var target = idx * (sw / total);
          try { thumbsWrap.scrollTo({ left: target, behavior: 'smooth' }); }
          catch (e) { thumbsWrap.scrollLeft = target; }
          setTimeout(function () { _skipScrollSync = false; }, 600);
        }
      }
    }

    /* Prefetch full-size image on hover/focus so the eventual click is instant */
    var prefetched = {};
    function prefetchThumb(t) {
      var src = t && t.getAttribute('data-omes-img-src');
      if (!src || prefetched[src]) return;
      prefetched[src] = true;
      var pre = new Image();
      pre.src = src;
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click',     function () { activateThumb(i); syncSwatchToMedia(i); });
      t.addEventListener('mouseenter', function () { prefetchThumb(t); }, { passive: true });
      t.addEventListener('focusin',    function () { prefetchThumb(t); });
      t.addEventListener('touchstart', function () { prefetchThumb(t); }, { passive: true });
    });

    /* ---------- Mobile carousel: scroll → update active dot ---------- */
    if (thumbsWrap && total > 1) {
      var scrollTimer = null;
      thumbsWrap.addEventListener('scroll', function () {
        if (_skipScrollSync) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          if (_skipScrollSync) return;
          var sw = thumbsWrap.scrollWidth;
          if (!sw || !total) return;
          var idx = Math.round(thumbsWrap.scrollLeft / (sw / total));
          if (idx < 0) idx = 0;
          if (idx >= total) idx = total - 1;
          if (dots && dots.length) {
            dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
          }
          thumbs.forEach(function (t, i) { t.classList.toggle('omes-gallery-thumb--active', i === idx); });
          if (counter) counter.textContent = pad(idx + 1) + ' / ' + pad(total);
          syncSwatchToMedia(idx);
        }, 80);
      }, { passive: true });
    }

    /* ---------- Wishlist (uses theme's at_wishlist localStorage) ---------- */
    var wishBtn = root.querySelector('[data-omes-wishlist]');
    if (wishBtn) {
      var WL_KEY = 'at_wishlist';
      function readWL() {
        try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; }
      }
      function writeWL(arr) { localStorage.setItem(WL_KEY, JSON.stringify(arr)); }
      function syncWishUI() {
        var id = String(wishBtn.getAttribute('data-id'));
        var list = readWL();
        var on = list.indexOf(id) >= 0;
        wishBtn.classList.toggle('is-active', on);
        wishBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      wishBtn.addEventListener('click', function () {
        var id = String(wishBtn.getAttribute('data-id'));
        var list = readWL();
        var i = list.indexOf(id);
        if (i >= 0) list.splice(i, 1);
        else list.unshift(id);
        writeWL(list);
        syncWishUI();
        if (typeof window.checkWishlist === 'function') {
          try { window.checkWishlist(); } catch (e) {}
        }
      });
      syncWishUI();
    }

    /* ---------- Share ---------- */
    var shareBtn = root.querySelector('[data-omes-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url   = shareBtn.getAttribute('data-omes-share-url') || window.location.href;
        var title = shareBtn.getAttribute('data-omes-share-title') || document.title;
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
          return;
        }
        var done = function () {
          shareBtn.classList.add('is-copied');
          setTimeout(function () { shareBtn.classList.remove('is-copied'); }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy link:', url); });
        } else {
          window.prompt('Copy link:', url);
        }
      });
    }

    /* ---------- Zoom: Drift hover-zoom on desktop, sized to the source file ----------
       Shopify never upscales, so `image_url: width: 2000` on a 700x700 supplier
       shot still returns 700x700. Magnifying that by a fixed 2x just showed a
       blurred copy of what was already on screen, while the cursor still promised
       a zoom — which is what reads as "zoom is broken" on the lower-resolution
       catalogues. Measure what the file can actually deliver, zoom by that much
       (never more than 2x), and drop the affordance when there is no extra
       detail to reveal. */
    var TARGET_ZOOM     = 2;
    var MIN_USEFUL_ZOOM = 1.25;

    var driftInstance = null;
    var driftZoomSrc  = null;   /* zoom URL the live instance was built for */
    var zoomWidths    = {};     /* zoom URL → natural width, so re-visited thumbs don't re-probe */

    function teardownDrift() {
      if (driftInstance) {
        try { driftInstance.destroy(); } catch (e) {}
        driftInstance = null;
      }
      driftZoomSrc = null;
    }

    function setZoomAffordance(on) {
      if (!imgWrapper) return;
      if (on) imgWrapper.classList.add('przoom');
      else imgWrapper.classList.remove('przoom');
    }

    /* Natural width of the zoom source — Shopify caps it at the original's width */
    function measureZoomSrc(src, cb) {
      if (zoomWidths[src] !== undefined) { cb(zoomWidths[src]); return; }
      var probe = new Image();
      probe.onload  = function () { zoomWidths[src] = probe.naturalWidth; cb(zoomWidths[src]); };
      probe.onerror = function () { zoomWidths[src] = 0; cb(0); };
      probe.src = src;
    }

    function initDrift() {
      if (!imgWrapper) return;
      if (typeof Drift !== 'function') return;
      if (window.innerWidth < 1024) { teardownDrift(); setZoomAffordance(false); return; }
      var zoomSrc = imgWrapper.getAttribute('data-zoom');
      if (!zoomSrc) { teardownDrift(); setZoomAffordance(false); return; }
      if (driftZoomSrc === zoomSrc) return;   /* already built, or building, for this image */
      teardownDrift();
      driftZoomSrc = zoomSrc;
      measureZoomSrc(zoomSrc, function (naturalW) {
        /* The shopper may have moved to another thumb while the probe loaded */
        if (imgWrapper.getAttribute('data-zoom') !== zoomSrc) return;
        var shownW = imgWrapper.getBoundingClientRect().width;
        if (!naturalW || !shownW) { setZoomAffordance(false); return; }
        var available = naturalW / shownW;
        if (available < MIN_USEFUL_ZOOM) { setZoomAffordance(false); return; }
        setZoomAffordance(true);
        try {
          driftInstance = new Drift(imgWrapper, {
            paneContainer: imgWrapper,
            inlinePane: false,
            zoomFactor: Math.min(available, TARGET_ZOOM)
          });
        } catch (e) { console.warn('Drift init failed', e); }
      });
    }

    /* Re-measure after a swap: initDrift() keys off data-zoom, which swapMainImage
       has already updated by the time it calls us. */
    if (typeof Drift === 'function') {
      initDrift();
    } else {
      var driftWait = setInterval(function () {
        if (typeof Drift === 'function') { clearInterval(driftWait); initDrift(); }
      }, 100);
      setTimeout(function () { clearInterval(driftWait); }, 5000);
    }
    var resizeZoomTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeZoomTimer);
      resizeZoomTimer = setTimeout(function () {
        /* the displayed width drives the factor, so a resize needs a fresh build */
        teardownDrift();
        initDrift();
      }, 200);
    });

    /* Narrow the pills to the colour the page loaded with. */
    refreshOptionAvailability();

    /* ---------- Init variant from URL ---------- */
    try {
      var params = new URLSearchParams(window.location.search);
      var v = params.get('variant');
      if (v && variants.length) {
        var match = variants.find(function (x) { return String(x.id) === String(v); });
        if (match && match.options) {
          /* Colour first: picking it re-opens the sizes that only exist in
             that colour, which a size-first order would have crossed out. */
          var picks = match.options.map(function (label, i) { return { label: label, i: i }; });
          picks.sort(function (a, b) {
            var isSwatch = function (n) { return root.querySelector('button.omes-swatch[data-omes-option="' + n + '"]') ? 0 : 1; };
            return isSwatch(a.i) - isSwatch(b.i);
          });
          picks.forEach(function (pick) {
            var label = pick.label;
            var i = pick.i;
            var sel = root.querySelector('select[data-omes-option="' + i + '"]');
            if (sel) {
              for (var j = 0; j < sel.options.length; j++) {
                if ((sel.options[j].getAttribute('data-omes-option-label') || sel.options[j].value) === label) {
                  sel.selectedIndex = j;
                  sel.dispatchEvent(new Event('change'));
                  break;
                }
              }
              return;
            }
            var btn = root.querySelector('button[data-omes-option="' + i + '"][data-omes-option-label="' + cssEscape(label) + '"]');
            if (btn) btn.click();
          });
        }
      }
    } catch (e) {}

    var bundlesEl = root.querySelector('[data-omes-bundles]');
    if (bundlesEl) {
      initBundles(bundlesEl, {
        root: root, form: form, variants: variants, idInput: idInput, atcBtn: atcBtn,
        buyNowBtn: buyNowBtn, atcPrice: atcPrice, qtyEl: qtyEl, stockEl: stockEl
      });
    }
  }

  /* ---------- OMES Bundles: what sets and quantity offers share ----------
     Both reach the cart as ordinary lines tagged with a hidden `_omes_bundle`
     property, and a Shopify discount code kept by the marketplace app brings them
     down to the bundle's price. assets/omes-bundles.js puts that code on the cart
     after every change; add-to-cart below asks it to right away.
     Contract: omes_multi_vendor docs/backlog_omes_bundles.md « The cart contract ». */

  var BUNDLE_PROPERTY = '_omes_bundle';

  /* Cents as the shop writes money, for prices computed here rather than in Liquid. */
  function bundleMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    try {
      if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
        return window.theme.Currency.formatMoney(cents, format);
      }
    } catch (e) { /* the shop's format, applied below */ }
    return bundleFormatMoney(cents, format);
  }

  /* The shop's money format, for the first paint: this file runs before the theme
     script that defines theme.Currency. Same placeholders as Shopify's formatMoney. */
  function bundleFormatMoney(cents, format) {
    var open = format.indexOf('{{');
    var close = format.indexOf('}}', open);
    if (open < 0 || close < 0) return (cents / 100).toFixed(2);
    function group(decimals, thousands, decimal) {
      var parts = (Math.round(cents) / 100).toFixed(decimals).split('.');
      var whole = parts[0];
      var out = '';
      for (var i = 0; i < whole.length; i++) {
        if (i > 0 && (whole.length - i) % 3 === 0) out += thousands;
        out += whole.charAt(i);
      }
      return parts[1] ? out + decimal + parts[1] : out;
    }
    var value;
    switch (format.slice(open + 2, close).trim()) {
      case 'amount_no_decimals': value = group(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = group(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = group(0, '.', ','); break;
      case 'amount_with_space_separator': value = group(2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = group(0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = group(2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': value = group(2, ' ', '.'); break;
      default: value = group(2, ',', '.');
    }
    return format.slice(0, open) + value + format.slice(close + 2);
  }

  function bundleShowError(form, message) {
    var scope = form.closest('product-form') || form;
    var wrap = scope.querySelector('.product-form__error-message-wrapper');
    var slot = wrap && wrap.querySelector('.product-form__error-message');
    if (wrap && slot) { slot.textContent = message; wrap.hidden = false; return; }
    window.alert(message);
  }

  /* Posts a bundle's lines to the cart, renders the drawer, then puts the bundle's code on the cart. */
  function addBundleItems(form, btn, items, errorMessage) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var scope = form.closest('product-form') || form;
    var wrap = scope.querySelector('.product-form__error-message-wrapper');
    if (wrap) wrap.hidden = true;
    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');
    // Where focus returns when the drawer closes, as the theme's product-form sets it.
    if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) throw new Error(res.body.description || res.body.message || errorMessage);
        var drawn = !!(cart && typeof cart.renderContents === 'function' && res.body.sections);
        if (drawn) {
          // A drawer still marked empty traps focus on its empty state, which the new contents replaced.
          cart.classList.remove('is-empty');
          cart.renderContents(res.body);
        }
        var codes = window.OmesBundles ? window.OmesBundles.reconcile() : Promise.resolve(null);
        return codes.then(function () {
          if (!drawn) window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        });
      })
      .catch(function (err) { bundleShowError(form, (err && err.message) || errorMessage); })
      .then(function () {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      });
  }

  /* ---------- OMES Bundles block (« Acheter en ») ----------
     snippets/omes-pdp-bundles.liquid, drawn after the design in
     D:/omes/Assets/omes-pdp-bundles. Every price shown is what the product's OMES-
     codes charge: a tier's amount per unit (`data-off`, in cents) and a set's rule
     come from the metafields omes_multi_vendor writes. The page's own add-to-cart and
     buy-now buttons carry the choice, relabelled and repriced here.
       offers · « Pièce seule »: 1 unit, or a tier of the selected variant;
                « Multipack »: a count per colour, one value per other option.
       set    · « L'ensemble »: one variant per piece, among those the set allows.
       box    · « Votre box »: one piece and one variant per slot; every slot must be filled. */

  var BUNDLE_TEXT = {
    add: 'Ajouter au panier',
    addPack: 'Ajouter le multipack',
    addSet: 'Ajouter l’ensemble',
    addBox: 'Ajouter la box',
    discount: 'Remise',
    setDiscount: 'Remise ensemble',
    boxDiscount: 'Remise box',
    total: 'Total',
    save: 'Économisez',
    piece: 'pièce',
    pieces: 'pièces',
    noDiscount: 'pas encore de remise',
    minPieces: 'Choisissez au moins {n} pièces.',
    unavailable: 'Cette combinaison est indisponible.',
    soldOutIn: 'Épuisé en {size}.',
    soldOut: 'Épuisé.',
    setUnavailable: 'Cet ensemble n’est pas disponible pour le moment.',
    pieceUnavailable: 'Une pièce de cet ensemble est indisponible pour le moment.',
    setPrice: 'Prix de l’ensemble',
    boxPrice: 'Prix de la box',
    boxUnavailable: 'Cette box n’est pas disponible pour le moment.',
    boxLeftOne: 'Encore 1 article à choisir',
    boxLeft: 'Encore {n} articles à choisir',
    addError: "Impossible d'ajouter ces articles au panier."
  };
  var PACK_MAX = 10;

  function bundleEsc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function initBundles(el, ui) {
    var kind = el.getAttribute('data-kind');
    var bundleValue = el.getAttribute('data-bundle') || '';
    var itemsInput = el.querySelector('[data-omes-bundle-items]');
    var sumEl = el.querySelector('[data-sum]');
    var errEl = el.querySelector('[data-err]');
    // The « Acheter en » choice sits under the price, outside this block (part: 'modes').
    var modesEl = ui.root.querySelector('[data-omes-bundle-modes] [data-modes]') || el.querySelector('[data-modes]');
    if (!itemsInput || !ui.form) return;

    var state = { mode: 'single', qty: 1 };

    function q(sel, ctx) { return (ctx || el).querySelector(sel); }
    function qa(sel, ctx) { return Array.prototype.slice.call((ctx || el).querySelectorAll(sel)); }
    function press(nodes, match) { nodes.forEach(function (n) { n.setAttribute('aria-pressed', String(!!match(n))); }); }
    function int(value) { return parseInt(value, 10) || 0; }
    function matches(options, chosen) {
      return (options || []).every(function (value, i) { return chosen[i] == null || chosen[i] === value; });
    }

    /* ---- offers: the tiers, and the variant the page selects ---- */
    var tiers = qa('.b-tier').map(function (card) {
      return { card: card, quantity: int(card.getAttribute('data-qty')), off: int(card.getAttribute('data-off')) };
    });
    var minTier = tiers.reduce(function (min, t) { return t.quantity > 1 && (!min || t.quantity < min) ? t.quantity : min; }, 0) || 2;

    function mainVariant() {
      var id = ui.idInput ? String(ui.idInput.value) : '';
      for (var i = 0; i < ui.variants.length; i++) if (String(ui.variants[i].id) === id) return ui.variants[i];
      return ui.variants[0] || null;
    }
    function variantLabel(v) {
      var shown = ((v && v.options) || []).filter(function (o) { return o && o !== 'Default Title'; });
      return (el.getAttribute('data-product-title') || '') + (shown.length ? ' · ' + shown.join(' / ') : '');
    }
    // The amount a code takes off each unit once `units` reach its tier (0 below the first).
    function offFor(units) {
      var best = null;
      tiers.forEach(function (t) {
        if (t.quantity > 1 && t.quantity <= units && (!best || t.quantity > best.quantity)) best = t;
      });
      return best ? best.off : 0;
    }

    /* ---- multipack ---- */
    var packPanel = q('[data-panel="pack"]');
    function packChoice() {
      var chosen = [];
      qa('[data-pack-option]').forEach(function (group) {
        var pressed = q('.b-opt[aria-pressed="true"]', group);
        chosen[int(group.getAttribute('data-pack-option'))] = pressed ? pressed.getAttribute('data-value') : null;
      });
      return chosen;
    }
    function packChoiceText() {
      return packChoice().filter(function (v) { return v; }).join(' / ');
    }
    function packVariant(color) {
      var chosen = packChoice();
      chosen[int(packPanel.getAttribute('data-color-index'))] = color;
      for (var i = 0; i < ui.variants.length; i++) {
        if (matches(ui.variants[i].options, chosen)) return ui.variants[i];
      }
      return null;
    }

    /* ---- set ---- */
    var pieces = qa('[data-piece]').map(function (row) {
      var variants = [];
      try { variants = JSON.parse((q('[data-piece-variants]', row) || {}).textContent || '[]') || []; } catch (e) { variants = []; }
      return {
        row: row,
        variants: variants,
        quantity: Math.max(1, int(row.getAttribute('data-quantity'))),
        productId: row.getAttribute('data-product-id') || '',
        label: row.getAttribute('data-label') || ''
      };
    });
    var setRule = el.getAttribute('data-rule') || '';
    var setAmount = int(el.getAttribute('data-amount'));
    var setGetProduct = el.getAttribute('data-get-product') || '';
    var setPercentage = parseFloat(el.getAttribute('data-percentage'));

    function pieceChosen(piece) {
      var chosen = [];
      qa('[data-option][aria-pressed="true"]', piece.row).forEach(function (btn) {
        chosen[int(btn.getAttribute('data-option'))] = btn.getAttribute('data-value');
      });
      return chosen;
    }
    function pieceVariant(piece) {
      var chosen = pieceChosen(piece);
      var complete = qa('[data-option]', piece.row).every(function (btn) {
        return chosen[int(btn.getAttribute('data-option'))] != null;
      });
      if (!complete) return null;
      for (var i = 0; i < piece.variants.length; i++) {
        if (matches(piece.variants[i].options, chosen)) return piece.variants[i];
      }
      return null;
    }
    // What the set's code takes off this piece: every unit (amount_each), or the « get »
    // piece only (buy_x_get_y, as an amount or the percentage Shopify took).
    function pieceSaving(piece, variant) {
      var off = 0;
      if (setRule === 'amount_each') off = setAmount;
      else if (setRule === 'buy_x_get_y' && piece.productId === setGetProduct) {
        off = isNaN(setPercentage) ? setAmount : Math.round(variant.price * setPercentage);
      }
      return Math.min(off, variant.price) * piece.quantity;
    }
    // After a colour pick, a size that colour does not come in moves to one it does.
    function settlePiece(piece) {
      var groups = {};
      qa('.b-opt[data-option]', piece.row).forEach(function (btn) {
        var i = btn.getAttribute('data-option');
        (groups[i] = groups[i] || []).push(btn);
      });
      Object.keys(groups).forEach(function (i) {
        var chosen = pieceChosen(piece);
        var possible = groups[i].filter(function (btn) {
          var probe = chosen.slice();
          probe[int(i)] = btn.getAttribute('data-value');
          return piece.variants.some(function (v) { return v.available && matches(v.options, probe); });
        });
        var current = groups[i].filter(function (btn) { return btn.getAttribute('aria-pressed') === 'true'; })[0];
        if (possible.length && possible.indexOf(current) === -1) press(groups[i], function (btn) { return btn === possible[0]; });
      });
    }

    /* ---- box: a slot holds a piece of the list, then its options ---- */
    var boxPieces = [];
    if (kind === 'box') {
      try { boxPieces = JSON.parse((q('[data-box-pieces]') || {}).textContent || '[]') || []; } catch (e) { boxPieces = []; }
    }
    var boxAmount = int(el.getAttribute('data-amount'));
    var slots = qa('[data-slot]').map(function (row) { return { row: row, piece: null, chosen: [] }; });

    function slotVariant(slot) {
      if (!slot.piece) return null;
      var hits = slot.piece.variants.filter(function (v) {
        return v.options.every(function (value, i) { return slot.chosen[i] === value; });
      });
      return hits[0] || null;
    }
    // The values a slot's piece offers for option `index`, in the order it lists them.
    function slotValues(piece, index) {
      var seen = [];
      piece.variants.forEach(function (v) {
        if (v.options[index] != null && seen.indexOf(v.options[index]) === -1) seen.push(v.options[index]);
      });
      return seen;
    }
    function slotPossible(slot, index, value) {
      return slot.piece.variants.some(function (v) {
        return v.available && v.options[index] === value && v.options.every(function (other, i) {
          return i >= index || slot.chosen[i] === other;
        });
      });
    }
    // A question with one answer is not asked; a choice an earlier one ruled out is dropped.
    function settleSlot(slot) {
      slot.piece.options.forEach(function (name, index) {
        var open = slotValues(slot.piece, index).filter(function (value) { return slotPossible(slot, index, value); });
        if (open.indexOf(slot.chosen[index]) === -1) slot.chosen[index] = open.length === 1 ? open[0] : undefined;
      });
    }
    function drawSlot(slot) {
      var host = q('[data-slot-options]', slot.row);
      qa('.b-pick', slot.row).forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(!!slot.piece && boxPieces[int(btn.getAttribute('data-pick-piece'))] === slot.piece));
      });
      if (!slot.piece) { host.innerHTML = ''; return; }
      host.innerHTML = slot.piece.options.map(function (name, index) {
        var values = slotValues(slot.piece, index);
        if (values.length === 1 && values[0] === 'Default Title') return '';
        return '<div class="b-opts" role="group" aria-label="' + bundleEsc(name) + '">' + values.map(function (value) {
          return '<button type="button" class="b-opt" data-slot-option="' + index + '" data-value="' + bundleEsc(value) + '"' +
            ' aria-pressed="' + (slot.chosen[index] === value) + '"' + (slotPossible(slot, index, value) ? '' : ' disabled') + '>' +
            bundleEsc(value) + '</button>';
        }).join('') + '</div>';
      }).join('');
    }

    /* An arrow shows only where the strip has more to show. */
    function updateStrip(wrap) {
      var strip = q('.b-strip', wrap);
      var end = strip.scrollWidth - strip.clientWidth;
      q('[data-strip-arrow="-1"]', wrap).hidden = strip.scrollLeft <= 2;
      q('[data-strip-arrow="1"]', wrap).hidden = strip.scrollLeft >= end - 2;
    }
    var strips = qa('[data-strip]');
    strips.forEach(function (wrap) {
      q('.b-strip', wrap).addEventListener('scroll', function () { updateStrip(wrap); }, { passive: true });
      updateStrip(wrap);
    });
    if (strips.length) window.addEventListener('resize', function () { strips.forEach(updateStrip); });

    /* ---- what the choice costs, and what goes to the cart ---- */
    function props() {
      var p = {};
      p[BUNDLE_PROPERTY] = bundleValue;
      return p;
    }

    function computeSingle() {
      var r = { lines: [], gross: 0, save: 0, ok: true, err: '', items: [], label: BUNDLE_TEXT.add, formPost: false };
      var v = mainVariant();
      var tier = tiers.filter(function (t) { return t.quantity === state.qty; })[0] || tiers[0];
      var n = tier ? tier.quantity : 1;
      var unit = v ? int(v.price_cents) : 0;
      r.gross = unit * n;
      r.save = Math.min(tier ? tier.off : 0, unit) * n;
      r.lines.push({ name: variantLabel(v) + (n > 1 ? ' ×' + n : ''), price: r.gross });
      if (!v || !v.available) { r.ok = false; r.err = BUNDLE_TEXT.unavailable; r.soldOut = true; }
      // One unit goes through the product form, which carries the hidden `_omes_bundle`.
      if (n > 1 && v) r.items.push({ id: v.id, quantity: n, properties: props() });
      else r.formPost = true;
      return r;
    }

    function computePack() {
      var r = { lines: [], gross: 0, save: 0, ok: true, err: '', items: [], label: BUNDLE_TEXT.addPack, units: 0 };
      var counted = [];
      qa('[data-pack] .b-row').forEach(function (row) {
        var count = int(q('output', row).textContent);
        if (!count) return;
        var color = row.getAttribute('data-color');
        var v = packVariant(color);
        var price = v ? int(v.price_cents) : 0;
        var choice = packChoiceText();
        r.units += count;
        r.gross += price * count;
        r.lines.push({ name: color + (choice ? ' · ' + choice : '') + ' ×' + count, price: price * count });
        if (!v || !v.available) {
          r.ok = false;
          r.err = choice ? BUNDLE_TEXT.soldOutIn.replace('{size}', choice) : BUNDLE_TEXT.soldOut;
          return;
        }
        counted.push({ variant: v, count: count });
        r.items.push({ id: v.id, quantity: count, properties: props() });
      });
      var off = offFor(r.units);
      counted.forEach(function (c) { r.save += Math.min(off, int(c.variant.price_cents)) * c.count; });
      if (r.units < minTier) { r.ok = false; r.err = BUNDLE_TEXT.minPieces.replace('{n}', minTier); }
      return r;
    }

    function computeSet() {
      var r = { lines: [], gross: 0, save: 0, ok: !!bundleValue, err: bundleValue ? '' : BUNDLE_TEXT.setUnavailable, items: [], label: BUNDLE_TEXT.addSet };
      var title = el.getAttribute('data-set-title') || '';
      pieces.forEach(function (piece) {
        var v = pieceVariant(piece);
        if (!v || !v.available) {
          r.ok = false;
          if (!r.err) r.err = piece.variants.length ? BUNDLE_TEXT.unavailable : BUNDLE_TEXT.pieceUnavailable;
          return;
        }
        var shown = (v.options || []).filter(function (o) { return o && o !== 'Default Title'; });
        r.gross += v.price * piece.quantity;
        r.save += pieceSaving(piece, v);
        r.lines.push({
          name: piece.label + (shown.length ? ' · ' + shown.join(' / ') : '') + (piece.quantity > 1 ? ' ×' + piece.quantity : ''),
          price: v.price * piece.quantity
        });
        var p = props();
        p.Ensemble = title;
        r.items.push({ id: v.id, quantity: piece.quantity, properties: p });
      });
      if (!bundleValue) r.save = 0;
      return r;
    }

    function computeBox() {
      var r = { lines: [], gross: 0, save: 0, ok: !!bundleValue, err: bundleValue ? '' : BUNDLE_TEXT.boxUnavailable, items: [], label: BUNDLE_TEXT.addBox, left: 0 };
      var title = el.getAttribute('data-set-title') || '';
      var off = 0;
      slots.forEach(function (slot) {
        var v = slotVariant(slot);
        if (!v || !v.available) { r.ok = false; r.left++; return; }
        var shown = (v.options || []).filter(function (o) { return o && o !== 'Default Title'; });
        r.gross += v.price;
        off += Math.min(boxAmount, v.price);
        r.lines.push({ name: slot.piece.title + (shown.length ? ' · ' + shown.join(' / ') : ''), price: v.price });
        var same = r.items.filter(function (item) { return item.id === v.id; })[0];
        if (same) { same.quantity++; return; }
        var p = props();
        p.Box = title;
        r.items.push({ id: v.id, quantity: 1, properties: p });
      });
      // The code only comes with a full box: a partial total must not promise it.
      if (!r.left) r.save = off;
      return r;
    }

    function compute() {
      if (kind === 'box') return computeBox();
      if (kind === 'set') return computeSet();
      return state.mode === 'pack' ? computePack() : computeSingle();
    }

    /* ---- drawing ---- */
    function render() {
      if (modesEl) press(qa('.b-mode', modesEl), function (n) { return n.getAttribute('data-mode') === state.mode; });
      // « Multipack » picks its own colours and size: CSS hides the page's pickers then.
      if (kind === 'offers') ui.root.setAttribute('data-omes-bundle-mode', state.mode);
      qa('.b-panel').forEach(function (panel) {
        var name = panel.getAttribute('data-panel');
        panel.setAttribute('data-active', String(kind === 'set' ? name === 'set' : name === state.mode));
      });

      if (kind === 'offers') {
        var v = mainVariant();
        var unit = v ? int(v.price_cents) : 0;
        press(tiers.map(function (t) { return t.card; }), function (card) { return int(card.getAttribute('data-qty')) === state.qty; });
        tiers.forEach(function (t) {
          var off = Math.min(t.off, unit);
          var priceEl = q('[data-tier-price]', t.card);
          var saveEl = q('[data-tier-save]', t.card);
          if (priceEl) priceEl.textContent = bundleMoney((unit - off) * t.quantity);
          if (saveEl) saveEl.textContent = off > 0 ? BUNDLE_TEXT.save + ' ' + bundleMoney(off * t.quantity) : '';
        });
        var modePrice = modesEl ? q('[data-mode-price]', modesEl) : null;
        if (modePrice) modePrice.textContent = bundleMoney(unit);

        if (packPanel) {
          qa('[data-pack] .b-row').forEach(function (row) {
            var pv = packVariant(row.getAttribute('data-color'));
            var ok = !!(pv && pv.available);
            var out = q('output', row);
            if (!ok) out.textContent = '0';
            row.setAttribute('data-oos', String(!ok));
            var note = q('[data-row-note]', row);
            var choice = packChoiceText();
            if (note) note.textContent = ok ? '' : (choice ? BUNDLE_TEXT.soldOutIn.replace('{size}', choice) : BUNDLE_TEXT.soldOut);
            qa('.b-step button', row).forEach(function (btn) {
              var step = int(btn.getAttribute('data-step'));
              var count = int(out.textContent);
              btn.disabled = !ok || (step < 0 && count === 0) || (step > 0 && count >= PACK_MAX);
            });
          });
          var pack = computePack();
          var packHint = q('[data-pack-hint]');
          if (packHint) {
            packHint.textContent = pack.units + ' ' + (pack.units > 1 ? BUNDLE_TEXT.pieces : BUNDLE_TEXT.piece) + ' · ' +
              (pack.save > 0 ? BUNDLE_TEXT.save.toLowerCase() + ' ' + bundleMoney(pack.save) : BUNDLE_TEXT.noDiscount);
          }
        }
      } else if (kind === 'box') {
        slots.forEach(drawSlot);
      } else {
        pieces.forEach(function (piece) {
          var chosen = pieceChosen(piece);
          qa('[data-option]', piece.row).forEach(function (btn) {
            var i = int(btn.getAttribute('data-option'));
            // A colour stays pickable whatever size is chosen; sizes follow the colour.
            var probe = btn.classList.contains('b-dot') ? [] : chosen.slice();
            probe[i] = btn.getAttribute('data-value');
            btn.disabled = !piece.variants.some(function (variant) { return variant.available && matches(variant.options, probe); });
          });
          var pv = pieceVariant(piece);
          var priceEl = q('[data-piece-price]', piece.row);
          if (priceEl && pv) priceEl.textContent = bundleMoney(pv.price * piece.quantity);
        });
      }

      var r = compute();
      var html = r.lines.map(function (line) {
        return '<div><span>' + bundleEsc(line.name) + '</span><span>' + bundleMoney(line.price) + '</span></div>';
      }).join('');
      if (r.save > 0) {
        html += '<div class="is-save"><span>' + (kind === 'box' ? BUNDLE_TEXT.boxDiscount : kind === 'set' ? BUNDLE_TEXT.setDiscount : BUNDLE_TEXT.discount) +
          '</span><span>−' + bundleMoney(r.save) + '</span></div>';
      }
      html += '<div class="is-total"><span>' + BUNDLE_TEXT.total + '</span><span>' + bundleMoney(r.gross - r.save) + '</span></div>';
      if (sumEl) sumEl.innerHTML = html;
      if (errEl) errEl.textContent = r.ok ? '' : r.err;

      if (kind !== 'offers') {
        var hint = q('[data-set-hint]');
        if (hint) {
          hint.textContent = r.ok
            ? (kind === 'box' ? BUNDLE_TEXT.boxPrice : BUNDLE_TEXT.setPrice) + ' ' + bundleMoney(r.gross - r.save) + (r.save > 0 ? ' · ' + BUNDLE_TEXT.save.toLowerCase() + ' ' + bundleMoney(r.save) : '')
            : !bundleValue || !r.left ? '' : r.left === 1 ? BUNDLE_TEXT.boxLeftOne : BUNDLE_TEXT.boxLeft.replace('{n}', r.left);
        }
        var note = q('[data-set-note]');
        if (note) note.textContent = r.ok && r.save > 0 ? BUNDLE_TEXT.save + ' ' + bundleMoney(r.save) : '';
      }

      var postItems = r.ok && r.items.length > 0 && !r.formPost;
      itemsInput.value = postItems ? JSON.stringify(r.items) : '';
      itemsInput.disabled = !postItems;

      if (ui.atcBtn) {
        ui.atcBtn.disabled = !r.ok;
        var label = ui.atcBtn.querySelector('[data-omes-atc-label]');
        if (label) label.textContent = r.soldOut ? (ui.atcBtn.getAttribute('data-omes-soldout') || r.label) : r.label;
      }
      if (ui.buyNowBtn) ui.buyNowBtn.disabled = !r.ok;
      if (ui.atcPrice) ui.atcPrice.textContent = '· ' + bundleMoney(r.gross - r.save);
      // The tiers and the pack set the quantity; the stepper would contradict them.
      if (ui.qtyEl) ui.qtyEl.style.display = 'none';
      if (kind !== 'offers' && ui.stockEl) {
        // A box being filled is not sold out: only an empty list is.
        var inStock = kind === 'box' ? !!bundleValue && !!q('.b-pick:not([disabled])') : r.ok;
        var stockLabel = ui.stockEl.querySelector('[data-omes-stock-label]');
        if (stockLabel) stockLabel.textContent = ui.stockEl.getAttribute(inStock ? 'data-omes-instock' : 'data-omes-outstock') || '';
      }
    }

    /* ---- listening ---- */
    if (modesEl) {
      modesEl.addEventListener('click', function (event) {
        var mode = event.target.closest('.b-mode');
        if (!mode) return;
        modesEl.setAttribute('data-idle', 'false');
        state.mode = mode.getAttribute('data-mode');
        render();
        // The panel it opens is further down, above the buy row: bring it into view
        // when the shopper would otherwise not see anything change.
        var panel = q('[data-panel="' + state.mode + '"]');
        if (panel && !el.contains(modesEl) && panel.getBoundingClientRect().top > window.innerHeight) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    el.addEventListener('click', function (event) {
      if (modesEl) modesEl.setAttribute('data-idle', 'false');

      var tier = event.target.closest('.b-tier');
      if (tier) { state.qty = int(tier.getAttribute('data-qty')) || 1; render(); return; }

      var packOpt = event.target.closest('[data-pack-option] .b-opt');
      if (packOpt) {
        press(qa('.b-opt', packOpt.parentNode), function (n) { return n === packOpt; });
        render();
        return;
      }

      var step = event.target.closest('[data-step]');
      if (step && !step.disabled) {
        var out = q('output', step.closest('.b-row'));
        out.textContent = String(Math.max(0, Math.min(PACK_MAX, int(out.textContent) + int(step.getAttribute('data-step')))));
        render();
        return;
      }

      var arrow = event.target.closest('[data-strip-arrow]');
      if (arrow) {
        var track = q('.b-strip', arrow.closest('[data-strip]'));
        track.scrollBy({ left: int(arrow.getAttribute('data-strip-arrow')) * track.clientWidth * 0.75, behavior: 'smooth' });
        return;
      }

      var pickBtn = event.target.closest('.b-pick');
      if (pickBtn && !pickBtn.disabled) {
        var pickSlot = slots.filter(function (s) { return s.row === pickBtn.closest('[data-slot]'); })[0];
        pickSlot.piece = boxPieces[int(pickBtn.getAttribute('data-pick-piece'))] || null;
        pickSlot.chosen = [];
        if (pickSlot.piece) settleSlot(pickSlot);
        render();
        return;
      }

      var slotOption = event.target.closest('[data-slot-option]');
      if (slotOption && !slotOption.disabled) {
        var slotRow = slots.filter(function (s) { return s.row === slotOption.closest('[data-slot]'); })[0];
        slotRow.chosen[int(slotOption.getAttribute('data-slot-option'))] = slotOption.getAttribute('data-value');
        settleSlot(slotRow);
        render();
        return;
      }

      var option = event.target.closest('[data-piece] [data-option]');
      if (option && !option.disabled) {
        var row = option.closest('[data-piece]');
        press(qa('[data-option="' + option.getAttribute('data-option') + '"]', row), function (n) { return n === option; });
        var piece = pieces.filter(function (p) { return p.row === row; })[0];
        if (piece && option.classList.contains('b-dot')) settlePiece(piece);
        render();
      }
    });

    // The page's own pickers change the variant a tier is priced on.
    ui.root.addEventListener('omes:variant-change', render);

    // Capture phase on the button: a bundle never goes through the product form, which
    // would post one variant (for a set, the set's own). One unit still does.
    if (ui.atcBtn) {
      ui.atcBtn.addEventListener('click', function (event) {
        var r = compute();
        if (kind === 'offers' && r.formPost) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (ui.atcBtn.disabled || ui.atcBtn.getAttribute('aria-disabled') === 'true') return;
        if (!r.ok || !r.items.length) return;
        addBundleItems(ui.form, ui.atcBtn, r.items, BUNDLE_TEXT.addError);
      }, true);
    }

    render();
  }

  function cssEscape(s) { return (s || '').replace(/(["\\])/g, '\\$1'); }

  function boot() {
    document.querySelectorAll('[data-omes-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
